export interface FounderPreviewSession {
  mode: 'payer_view';
  inviteToken: string;
  sessionId: string;
  auditSessionId: string;
  inviteName: string | null;
  startedAt: string;
  returnPath?: string;
}

const STORAGE_KEY = 'clero_founder_preview_session';

export const readFounderPreviewSession = (): FounderPreviewSession | null => {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as FounderPreviewSession;
  } catch {
    sessionStorage.removeItem(STORAGE_KEY);
    return null;
  }
};

export const persistFounderPreviewSession = (session: FounderPreviewSession) => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
};

export const clearFounderPreviewSession = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};
